import { Component, ElementRef, Input, OnInit, AfterViewInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EmployeeService } from '../employee-profile/employee-profile.service';
import { SharedSkillService } from '../skill-repository/shared-skill.service';
import { AuthServiceService } from '../../services/auth-service.service'
import { Subscription } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { SkillRepositoryService } from '../skill-repository/skill-repository.service';
import { DOCUMENT } from '@angular/common';
import { OthersService } from '../competencies/others/othersDataService';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ProfileCardDialog } from '../Dashboard/profile-card/profile-card.component';


export interface SkillSet {
  color: number;
  name: string;

}

export interface DialogData {
  empId: string
}


@Component({
  selector: 'app-skill-repo-employee-tiles',
  templateUrl: './skill-repo-employee-tiles.component.html',
  styleUrls: ['./skill-repo-employee-tiles.component.css', './skill-repo-employee-tiles.component.scss']
})
export class SkillRepoEmployeeTilesComponent implements OnInit, AfterViewInit {

  @Input() data: any;
  @Input() comingFromGlobalSearch: boolean;
  Avalibale: any;
  isSelectedAll = false;
  private subscription: Subscription;
  private isSelectedAllsubscription: Subscription;
  private cmpIdsubscription: Subscription;

  skillSets: SkillSet[] = [
    { color: 1, name: 'Microsoft' },
    { color: 1, name: '.Net' },
    { color: 1, name: 'Web API' },
    { color: 1, name: 'Sharepoint' },
    { color: 2, name: 'SSRS' },
    { color: 2, name: 'Mongo DB' },
    { color: 3, name: 'Tabluse' },

  ];
  subCompetencyName: string;
  competency: any;
  name: string;
  employeeId: string;
  compId: string;
  listOfEmployees: number[] = [];
  profileStatus: any;
  cmpId: string;
  Leadershiprole: boolean = false;
  constructor(private employeeService: EmployeeService,
    @Inject(DOCUMENT) private document: any,
    private toastr: ToastrService,
    private othersService: OthersService,
    private shareSkillService: SharedSkillService,
    private skillRepoService: SkillRepositoryService,
    private activeRoute: ActivatedRoute,
    private router: Router, private auth: AuthServiceService, private _fb: FormBuilder, public dialog: MatDialog) {
    this.subscription = this.shareSkillService.selectedValue$.subscribe(value => (this.Avalibale = value));
    this.isSelectedAllsubscription = this.shareSkillService.selectedAllCheckBoxes$.subscribe(value => (this.isSelectedAll = value));
    this.cmpIdsubscription = this.shareSkillService.pagenavigationId$.subscribe(value => {
      this.cmpId = value.resource;
    });


  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.cmpIdsubscription.unsubscribe();
    this.isSelectedAllsubscription.unsubscribe();
  }
  ngAfterViewInit(): void {

    const contentContainer = <any>$('.ellipse_id_data');
    if (contentContainer) {
      for (var i = 0; i < contentContainer.length; i++) {
        let vr = <any>$('.ellipse_id_data + .readmore_dots');
        if (contentContainer[i].scrollHeight >= 33) {
          vr[i].style.display = 'block';
        }
        else {
          vr[i].style.display = 'none';
        }

      }

    }
  }

  ngOnInit() {
    this.competency = localStorage.getItem('comptitle');
    this.name = localStorage.getItem('approvedata');
    var roles = this.auth.getRole();
    if (roles.indexOf('Leadership') >= 0) {
      this.Leadershiprole = true;
    }
    if (this.name != null) {
      this.name = this.name
    }
    else {
      this.name = ""
    }
    this.employeeId = this.shareSkillService.getEmployeeId();
    this.compId = localStorage.getItem('compId')

  }

  openDialog(employeeId: any) {
    this.dialog.open(ProfileCardDialog, {
      height: '85%',
      width: '60%',
      data: { employeeId: employeeId }
    });
  }
  naviagateToEmployeeDetails(id, mode, competency, competencyId, name) {
    this.shareSkillService.setEmployeeId(id)
    this.shareSkillService.setMode(mode)
    this.router.navigate([`Home/Skill Repository/${competency}/${name}/Employee Details`]);
  }
  navigateToEmpDetails(id, mode, competency, competencyId, name, isEditable, comingFromGlobalSearch) {
    this.shareSkillService.setEmployeeId(id);
    this.shareSkillService.setMode(mode);
    this.othersService.name$.subscribe(name => {
      this.subCompetencyName = name
      if (this.subCompetencyName == null || this.subCompetencyName == "") {
        this.subCompetencyName = sessionStorage.getItem("SubcompTitle")
      }
    });
    this.shareSkillService.setIsEditable(isEditable);
    this.activeRoute.params.subscribe((params) => {
      let paramName = params["name"]
      let filter = params["filter"]
      let competency = params["competency"]
      if (competency == undefined) {
        competency = this.data.filter((x) => x.employeeId == id).map((y) => y.competencyName);
      }

      if (paramName == undefined && filter == undefined && !comingFromGlobalSearch) {
        const url = this.router.serializeUrl(this.router.createUrlTree([`Home/skill_repo/${competency}/Employee Details/${id}`]));
        window.open(url, '_blank');
      }
      else if (paramName == undefined && filter == undefined && comingFromGlobalSearch) {
        const url = this.router.serializeUrl(this.router.createUrlTree([`Home/skill_repo/Employee Details/${id}`]));
        window.open(url, '_blank');
      }
      else if (paramName != undefined && filter == undefined) {
        const url = this.router.serializeUrl(this.router.createUrlTree([`Home/Skill Repository/${competency}/${paramName}/Employee Details/${id}`]));
        window.open(url, '_blank');
      }
      else if (filter != undefined) {
        let CMPID: number
        this.shareSkillService.pagenavigationId$.subscribe(values => {
          CMPID = values.resource
          if (CMPID == 0 || CMPID == undefined) {
            CMPID = Number(sessionStorage.getItem("resource"))
          }
        })
        if (CMPID == 1) {
          this.router.navigate([`Home/CMF Portal/${competency}/${this.subCompetencyName}/Resources/${filter}/Employee-details/${id}`]);
        }
        else if (CMPID == 2) {
          this.router.navigate([`Home/CMF Portal/${competency}/${this.subCompetencyName}/Certificates/${filter}/Employee-details/${id}`]);
        }
      }
    })
  }

  sampleMethod() {
    const competency = 'Digital Engineering'

  }
  getLetters(data) {
    if (data) {
      let words = data.split(' ');
      let str = '';
      words.forEach(x => {
        str = str + x.charAt(0);
      })
      return str;
    }
    return '';
  }
  getExperience(value) {
    let expYears = Math.floor(value);
    let expMonths = Math.round((value - expYears) * 12);
    if (expYears > 0) {
      if (expMonths > 0) {
        return expYears + " " + "Year(s)" + "  " + expMonths + " " + "Month(s)";
      }
      else {
        return expYears + " " + "Year(s)";
      }

    }
    else {
      return expMonths + " " + "Month(s)";

    }

  }
  getPrimaryDefaultSkills(primarySkills) {
    return primarySkills && primarySkills.length ? primarySkills.map(pri => pri.skill).join(', ') : null
  }
  getStringWithPipe(data, separator: string = " | ") {
    if (data) {
      var str = "";
      if (Array.isArray(data)) {
        data.forEach(x => {
          str = str + x + " " + separator + " ";
        })
      }
      else {
        str = str + data + " " + separator + " ";
      }
      return str.substring(0, str.length - 3);
    }
    return '';
  }

  getStringWithPipeWithDefaultValue(data, separator: string = " | ") {
    if (data) {
      var str = "";
      if (Array.isArray(data)) {
        data.forEach((x, index) => {
          if (index === 0) {
            str = x + "(Default) " + separator + " ";
          } else {
            str = str + x + " " + separator + " ";
          }
        });
      } else {
        str = "" + data + "(Default) " + separator + " ";
      }
      return str.substring(0, str.length - 3);
    }
    return '';
  }
  downloadResume(employeeId: any) {
    this.employeeService.fetchResume(employeeId).subscribe(res => {
      if (res.data) {
        var result = res.data
        var a = document.createElement("a");
        a.href = result.Extention + result.Data;
        a.download = result.Name; //File name Here
        a.click();
        a.remove();
      } else {
        this.toastr.warning("No Resume found for this profile")
      }
    })
  }
  isAuthorizedUser(id) {
    var roles = this.auth.getRole();
    if (roles.indexOf('SuperAdmin') >= 0 || roles.indexOf('Skill.Admin') >= 0 || roles.indexOf('Leadership') >= 0)
      return true
    else {
      if (roles.indexOf('Skill.User') >= 0) {
        if (id.toString() == this.auth.getEmployeeId())
          return true;
      }
    }
    return false;
  }
  ischecked(employeeId): boolean {
    return this.shareSkillService.getCheckedEmployeeIds().includes(employeeId);
  }
  isCompetencyString(value: any): boolean {
    if (value.length == 1) {
      return typeof value[0] === 'string';
    }
  }
  onCheckBoxChange(event: any, employeeId: number) {
    if (!event.target.checked) {
      this.isSelectedAll = false;
    }
    this.shareSkillService.updateCheckedEmployeeId(employeeId, event.target.checked);
  }
  cardColor: string = "#FFFFFF";
  cardText: string;
  cardTextColor: string;
  getTooltipText(status: number | undefined): string {
    switch (status) {
      case (1):
        this.cardColor = '#BEE2FD';
        this.cardTextColor = '#036CA7';
        this.cardText = 'S';
        return 'Submitted';
      case (2):
        this.cardColor = '#E4EAEE';
        this.cardTextColor = '#585858';
        this.cardText = 'N';
        return 'Not Submitted';
      case (3):
        this.cardColor = '#c9ecd9';
        this.cardTextColor = '#007e3a';
        this.cardText = 'A';
        return 'Approved';
      case (4):
        this.cardColor = '#FFCCCB';
        this.cardTextColor = '#E92C2C';
        this.cardText = 'R';
        return 'Rejected';
      default:
        this.cardText = 'U';
        return 'Unknown Status';
    }
  }
}


//Dialog
// @Component({
//   selector: 'profile-card-dialog',
//   templateUrl: 'profile-card-dialog.html',
// })
// export class ProfileCardDialog implements OnInit {
//   employeeId: number;
//   exp: any;
//   expYears: any;
//   expMonths: any;
//   loading: boolean = false;
//   employee: any;
//   employeeProfileBasicStatus: any;
//   competency:any;
//   domains:any;
//   certifications:any;
//   subCompetencyName:any;
//   experience:number=0;
//   expDomains:any[]=[];
//   expAreas:any[]=[]
//   empAreaExps:any;
//   primarySkills:any[]=[];
//   primarySkill:any[]=[];
//   empExpArea:any[]=[];
//   empAreaExp:any[] = [];
//   empAreaAndExp:any[]=[];
//   expAreaMonths:any[]=[];
//   expAreaMonth:any[]=[];
//   expAreaYears:any[]=[];
//   expAreaYear:any[]=[];
//   empExperience:string;
//   lastName:string;
//   firstName:string;
//   grade:string;
//   designation:string;
//   profileStatus: any;
//   constructor(private router: Router,private employeeService:EmployeeService,private toastr:ToastrService,private shareSkillService: SharedSkillService, private auth: AuthServiceService,public dialog: MatDialog,
//     @Inject(MAT_DIALOG_DATA) public data: any) {
//     this.employeeId = parseInt(data.empId);
//   }

//   ngOnInit() {
//     this.getProfileDetailsById(this.employeeId)
//   }

//   getProfileDetailsById(empId?: number) {
//   if (empId) {
//     this.loading = true;
//     this.employeeService.GetProfileDetailsById(empId).subscribe(
//       (res) => {
//         this.employee = res.data;
//         this.lastName = this.employee.lastName;
//         this.firstName = this.employee.firstName;
//         this.grade = this.employee.grade
//         this.designation = this.employee.designation;
//         this.employeeProfileBasicStatus = this.employee.employeeProfileStatus;
//         this.expDomains = this.employee.domains
//         this.exp = this.employee.experience
//         this.competency = this.employee.competencies.competencyName;
//         this.subCompetencyName = this.employee.competencies[0].subCompetencies[0].subCompetencyName;
//         this.expDomains= this.employee.domains == null ? ['No Data'] : this.employee.domains;
//         this.expYears = Math.floor(this.exp);
//         this.expMonths = Math.round((this.exp - this.expYears) * 12);
//         this.empExperience = parseInt(this.expYears) == 0 ? this.expMonths + " Months" : this.expYears + " Years " + this.expMonths + " Months";
//         this.empAreaExps = this.employee.competencies[0].subCompetencies[0].serviceAreas;
//         this.primarySkills = this.employee.competencies[0].subCompetencies[0].primarySkills;
//         this.profileStatus= this.getProfileStatus(this.employee.employeeProfileStatus);
//         // Expertise Area
//         for(let empAreaExp of this.empAreaExps){
//           let expYears = Math.floor(empAreaExp.experience);
//           let expMonths =  Math.round((empAreaExp.experience - expYears) * 12);
//           if (expYears > 0 || expMonths > 0){
//             this.expAreas.push(empAreaExp.serviceArea)
//             this.expAreaYear.push(expYears.toString())
//             this.expAreaMonth.push(expMonths.toString())
//           }
//         }
//         this.expAreaMonths = this.expAreaMonth;
//         this.expAreaYears = this.expAreaYear;
//         this.empAreaExps = this.expAreas == null ? ['No Data'] : this.expAreas;
//         for(var i=0;i<this.expAreas.length;i++){
//           let year = this.expAreaYears[i] == '1' ? " Year " : " Years ";
//           this.empAreaExp.push(this.expAreas[i] + "(" + this.expAreaYears[i] +year+this.expAreaMonths[i] + " Months"+ ")")
//         }
//         this.empAreaAndExp = this.empAreaExp.length == 0 ? ['No Data'] : this.empAreaExp;
//         // primary skill
//         if (this.primarySkills != null){
//           for(let skill of this.primarySkills){
//             this.primarySkill.push(skill.skill)
//             }
//           }
//           this.primarySkills = this.primarySkill.length == 0 ? ['No Data'] : this.primarySkill;
//         },
//         (error) => {
//           console.error('Error fetching employee details:', error);
//           this.loading = false;
//         }
//       );
//     }
//   }

// getProfileStatus(status: number){
//   switch(status){
//     case 1: return "Approval Pending"
//     case 2: return "Submission Pending"
//     case 3: return "Approved"
//     case 4: return "Rejected"
//     default : return "Unknown"
//   }
// }

//   closeDialog() {
//     this.dialog.closeAll();
//   }

// }

